import { DocsContextProvider } from "./docs.context"
import { ThemeProvider } from "./themeContext"
import { TourProvider } from "./tourContext"
import { MessageDrawerProvider } from "./message.drawer.context"
import { VoiceCallProvider } from "./voice.call.context"
import { ScheduleProvider } from "./schedule.context"

export default function Providers({ children }) {
    return (
        <DocsContextProvider>
            <ThemeProvider>
                <TourProvider>
                    <ScheduleProvider>
                        <VoiceCallProvider>
                            <MessageDrawerProvider>
                                {children}
                            </MessageDrawerProvider>
                        </VoiceCallProvider>
                    </ScheduleProvider>
                </TourProvider>
            </ThemeProvider>
        </DocsContextProvider>
    )
}